import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { getAppId, getAppType, setTStageID } from "../utility/Common";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import NavBar_appID from "./layout/NavBar_appID";
import ApplicationNo from "./PDF/ApplicationNo";

function Application() {
  let navigate = useNavigate();
  let p = getAppId();
  let d = new Date();
  let c = d?.toDateString();

  const ContinueApp = () => {
    const appType = getAppType();
    if (appType == 1 || appType == 2) {
      setTStageID(100)
      navigate("/anuani_ya_sasa");
    } else if (appType == 3) {
      setTStageID(210)
      navigate("/stp1B");
    } else if (appType == 4 || appType == 5) {
      setTStageID(210)
      navigate("/stp1");
    }
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <br />
              <div className="col-sm-6 text-justify">
                <h5 className="page-header m-r-t-1">
                  <Link to="#">Kidokezo Muhimu</Link>
                </h5>
                <p className="help-block help-block-error"></p>
                <p
                  align="justify"
                  style={{ fontSize: "14px", lineHeight: "1.6" }}
                >
                  Tafadhali hifadhi{" "}
                  <strong>
                    Namba ya Utambulisho (Reference ID) &nbsp;
                    {p?.toUpperCase()}
                    &nbsp;
                  </strong>
                  sehemu salama, kwani itahitajika pindi Mwombaji atakapohitaji
                  KUENDELEA na Ombi lake hapo baadae.
                  <br />
                  <br /> Aidha, Namba hiyo itahitajika pia endapo kutatokea
                  tatizo la kukatika kwa mawasiliano wakati Mwombaji anajaza
                  fomu, au ikiwa anahitaji kukatisha ujazaji wa fomu yake kwa
                  sasa, na kuendelea kutoka pale alipoishia hapo baadaye.
                </p>
              </div>
              <div className="col-sm-1"></div>

              <div className="col-sm-5" id="PrintThis">
                <Link>
                  <h5 className="page-header m-r-t-1">Namba ya Utambulisho</h5>
                </Link>
                <p className="help-block help-block-error"></p>
                <p style={{ fontSize: "15px", lineHeight: "1.6" }}>
                  Namba ya Utambulisho wako <br />
                  <b>{p?.toUpperCase()}</b>
                </p>
                <p style={{ fontSize: "15px", lineHeight: "1.6" }}>
                  <br />
                  Tarehe <br />
                  <b>{c}</b>
                </p>
              </div>

              <div className="col-sm-6"></div>
              <div className="col-sm-1"></div>
              <div className="col-sm-5 box-footer">
                {<ApplicationNo />}
                <button
                  className="btn btn-default btn-label-next pull-right"
                  onClick={ContinueApp}
                >
                  Endelea na Ombi | <i className="fa fa-angle-double-right"></i>{" "}
                </button>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Application;
